import { z } from 'zod';
import { FACE_CAPTURE_DRIVERS, FINGERPRINT_DRIVERS, SIGNATURE_DRIVERS } from '../types/devices.js';
/**
 * Payload de capture biométrique (Sprint 3) — la forme de `capture` reprend
 * exactement les contrats `FingerprintCaptureResult` / `SignatureCaptureResult`
 * / `FaceCaptureResult` de `../types/devices.ts`, produits par les pilotes
 * matériels du front (voir docs/hardware-integration.md). L'API ne fait que
 * valider ce que le pilote a déjà produit, elle ne parle jamais au matériel.
 */
const fingerprintCaptureSchema = z.object({
    driver: z.enum(FINGERPRINT_DRIVERS),
    imageBase64: z.string().min(1),
    imageFormat: z.enum(['bmp', 'png']),
    qualityScore: z.number().min(0).max(100),
    deviceId: z.string().optional(),
    capturedAt: z.string(),
});
const signatureCaptureSchema = z.object({
    driver: z.enum(SIGNATURE_DRIVERS),
    imageBase64: z.string().min(1),
    imageFormat: z.literal('png'),
    capturedAt: z.string(),
});
const faceCaptureSchema = z.object({
    driver: z.enum(FACE_CAPTURE_DRIVERS),
    imageBase64: z.string().min(1),
    imageFormat: z.literal('jpeg'),
    livenessScore: z.number().min(0).max(100).optional(),
    capturedAt: z.string(),
});
export const FINGERPRINT_SOUS_TYPES = [
    'pouce_gauche',
    'pouce_droit',
    'index_gauche',
    'index_droit',
];
export const createBiometrieCaptureSchema = z.discriminatedUnion('typeBiometrie', [
    z.object({
        typeBiometrie: z.literal('empreinte'),
        sousType: z.enum(FINGERPRINT_SOUS_TYPES),
        capture: fingerprintCaptureSchema,
    }),
    z.object({
        typeBiometrie: z.literal('visage'),
        sousType: z.string().max(20).optional(),
        capture: faceCaptureSchema,
    }),
    z.object({
        typeBiometrie: z.literal('signature'),
        sousType: z.string().max(20).optional(),
        capture: signatureCaptureSchema,
    }),
]);
//# sourceMappingURL=biometrie.js.map